import service from '../service.js'

export default {

    getRequest(){
      return service.get('training')
    },

    getData(ref_no){
      return service.get('training-data',{
            ref_no : ref_no
      })
    },

    approveRequest(ref_no, type){
      return service.post('training-approve',{
            ref_no : ref_no,
            type   : type
      })
    },

    trainingPdf(ref_no){
      return service.get('training-pdf',{
            ref_no : ref_no,
      })
    },
}